import _defineProperty from "@babel/runtime/helpers/defineProperty";


import { css } from 'styled-components';
import { Size } from './types';
var _sizeStatusLabelMixin;
export var sizeStatusLabelMixin = (_sizeStatusLabelMixin = {}, _defineProperty(_sizeStatusLabelMixin, Size.Sm, css(["font-weight:normal;font-size:12px;line-height:14px;padding:4px 8px;"])), _defineProperty(_sizeStatusLabelMixin, Size.Md, css(["font-weight:normal;font-size:14px;line-height:16px;padding:4px 12px;"])), _sizeStatusLabelMixin);